import { render, staticRenderFns } from "./VegetationList.vue?vue&type=template&id=f20e10d0&scoped=true&"
import script from "./VegetationList.vue?vue&type=script&lang=js&"
export * from "./VegetationList.vue?vue&type=script&lang=js&"
import style0 from "./VegetationList.vue?vue&type=style&index=0&id=f20e10d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20e10d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VDataTable,VIcon})
